module.exports = __webpack_public_path__ + "media/packs/src/webfonts/fa-regular-400-814c2c571f030686e71cb97ad8f43884.ttf";